import React from 'react';
import useQualificationStructureService from './services/qualificationStructureService';
import { List, ListData, ListPageLayout } from 'framework/list';
import StructureComparisonGrid from './StructureComparisonGrid';

const StructureComparison = () => {
  const { getActiveQualificationStructure } = useQualificationStructureService();
  const getCategory = (percent: number) => {
    if (percent > 100) return 2;
    if (percent < 100) return 1;
    return 0;
  };

  const getGroup = (rule: any) => {
    if (rule.competencyLevel === null && rule.positionId === null) return 0;
    if (
      (rule.competencyLevel !== null && rule.positionId === null) ||
      (rule.competencyLevel === null && rule.positionId !== null)
    )
      return 1;

    return 2;
  };

  const sortInputData = (input: ListData): ListData => {
    return {
      result: input.result.sort((a, b) => {
        const groupA = getGroup(a);
        const groupB = getGroup(b);

        if (groupA !== groupB) {
          return groupA - groupB;
        }

        const categoryA = getCategory(a.fulfillmentPercentage);
        const categoryB = getCategory(b.fulfillmentPercentage);

        if (categoryA !== categoryB) {
          return categoryB - categoryA;
        }

        if (categoryA === 2) {
          return b.fulfillmentPercentage - a.fulfillmentPercentage;
        } else if (categoryA === 1) {
          return a.fulfillmentPercentage - b.fulfillmentPercentage;
        }

        return 0;
      }),
    };
  };

  return (
    <>
      <List getDataMethod={loadParams => getActiveQualificationStructure(loadParams).then(res => sortInputData(res))}>
        <ListPageLayout sxFilter={{ pl: 2 }} sxPaper={{ backgroundColor: 'transparent', p: '0 !important' }}>
          <StructureComparisonGrid />
        </ListPageLayout>
      </List>
    </>
  );
};

export default StructureComparison;
